import { Component, inject, OnInit } from '@angular/core';
import { RouterModule } from '@angular/router';
import { IonicModule } from '@ionic/angular';
import { UserService } from 'army-builder-shared';

@Component({
    standalone: true,
    imports: [IonicModule, RouterModule],
    selector: 'wl-game-list',
    template: `
        <div class="banners">
            <div class="gameTile">
                <div class="banner">
                    <img src="/assets/images/banners/bolt-action.png" alt="Bolt Action" />
                </div>
                <div class="buttons">
                    <ion-button [routerLink]="['/bolt-action-3e']">List Builder</ion-button>
                    <ion-button [routerLink]="['/bolt-action-3e/library']">Library</ion-button>
                </div>
            </div>

            <!-- @if (hasRole('k47-early-access')) { -->
            <div class="gameTile">
                <div class="banner">
                    <img src="/assets/images/banners/konflikt-47.png" alt="Konflikt 47" />
                </div>
                <div class="buttons">
                    <ion-button [routerLink]="['/k47']">List Builder</ion-button>
                    <ion-button [routerLink]="['/k47/library']">Library</ion-button>
                </div>
            </div>
            <!-- } -->

            <div class="gameTile">
                <div class="banner">
                    <img src="/assets/images/banners/black-seas.png" alt="Black Seas" />
                </div>
                <div class="buttons">
                    <ion-button [routerLink]="['/black-seas']">Fleet Builder</ion-button>
                    <ion-button [routerLink]="['/black-seas/battle']">Battle Tracker</ion-button>
                </div>
            </div>

            <div class="gameTile">
                <div class="banner">
                    <img src="/assets/images/banners/blood-red-skies.png" alt="Blood Red Skies" />
                </div>
                <div class="buttons">
                    <ion-button [routerLink]="['/blood-red-skies']">Squadron Builder</ion-button>
                </div>
            </div>
        </div>
    `,
    styles: [
        `
            .banners {
                display: grid;
                grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));
                gap: 20px;
                padding: 20px 0;
                justify-items: center;
                align-items: start;
                width: 100%;
                box-sizing: border-box;
                max-width: 800px;
                margin: 0 auto;
            }

            .gameTile {
                --btn-border-radius: 0;
                max-width: 520px;
            }

            .banner {
                position: relative;
                border-top: 0;
                height: 120px;
                display: flex;
                align-items: center;
                overflow: hidden;
                border: 3px solid black;
                border-bottom: 0;
            }

            .buttons {
                background: black;
                padding: 0;
                margin: 0 0 10px;
                border: 2px solid black;
                gap: 0;
            }

            ion-button {
                margin: 1px;
                white-space: nowrap;
            }

            img {
                display: block;
            }

            h2 {
                background: rgba(0, 0, 0, 0.7);
                padding: 10px 20px;
                color: white;
                position: absolute;
                bottom: 0;
                left: 0;
                right: 0;
                margin: 0;
            }

            @media (max-width: 599px) {
                .banners {
                    display: flex;
                    flex-direction: column;
                    align-items: stretch;
                }

                .banners {
                }

                .banner {
                    position: relative;
                    display: flex;
                    align-items: center;
                    overflow: hidden;
                }

                img {
                    display: block;
                }

                h2 {
                    background: rgba(0, 0, 0, 0.7);
                    padding: 10px 20px;
                    color: white;
                    position: absolute;
                    bottom: 0;
                    left: 0;
                    right: 0;
                    margin: 0;
                }
            }
        `
    ]
})
export class GameListPage {
    userService = inject(UserService);

    constructor() {}

    getTranslationKey(gameId: string) {
        return 'GLOBAL.MENU_ITEMS.' + gameId.replace(/\-/g, '_').toUpperCase();
    }

    hasRole(role: string): boolean {
        return this.userService.user().roles?.includes(role);
    }
}
